module.exports = require("@mui/icons-material/ContentPaste");